import { render, staticRenderFns } from "./gc-small-status.vue?vue&type=template&id=7c35590a&scoped=true&"
import script from "./gc-small-status.vue?vue&type=script&lang=js&"
export * from "./gc-small-status.vue?vue&type=script&lang=js&"
import style0 from "./gc-small-status.vue?vue&type=style&index=0&id=7c35590a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35590a",
  null
  
)

export default component.exports